var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-628 -619)",
    clipPath: "url(#facebook_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.191 640.573l.621-4.045h-3.885V633.9a2.023 2.023 0 012.281-2.185h1.765v-3.442a21.518 21.518 0 00-3.134-.273c-3.2 0-5.286 1.937-5.286 5.445v3.083H642v4.045h3.554v9.779h4.373v-9.779z",
    fill: "currentColor"
  }))));
}
export default SvgFacebook;